export const LanguageController = () => {

    $('.js-language-toggle').click((e) => {
      $('.js-language-drop').slideToggle();
    });
  
  }


// WEBPACK FOOTER //
// ./src/js/controllers/LanguageController.js